import React, { useState } from "react";

import Loading from "src/components/Loading";
import { baseRoute } from "src/config";
import CouponList from "./CouponList";

const Coupons = () => {
  const [isLoading, setIsLoading] = useState(true);

  const qs = window.location.search;
  const getCouponById = async (couponId) => {
    window.location.href = `${baseRoute}/coupon/${couponId}` + qs;
  };

  return (
    <>
      {isLoading && <Loading />}
      <CouponList setIsLoading={setIsLoading} getCouponById={getCouponById} />
    </>
  );
};

export default Coupons;
